import { faArrowRight } from "@fortawesome/pro-regular-svg-icons/faArrowRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useCartStore } from "../stores/CartStore";
import { PromoCodes } from "./PromoCodes";

import "../assets/scss/components/_discount-code.scss";

export const DiscountCode = () => {
	const { discountCode, discountMessage, SetDiscountCode, ApplyDiscount, discountStatus } = useCartStore(
		({ discountCode, discountMessage, SetDiscountCode, ApplyDiscount, discountStatus }) => {
			return { discountCode, discountMessage, SetDiscountCode, ApplyDiscount, discountStatus };
		},
	);

	return (
		<div className="discount-code-wrapper">
			<div className="coupon-code-section">
				<span>Have a coupon code?</span>
				<div className="field">
					<input
						type="text"
						placeholder=" "
						value={discountCode}
						onChange={(e) => SetDiscountCode(e.target.value.trim())}
					/>
					<label htmlFor="">Coupon Code</label>
					<button className="btn apply-discount-button" onClick={() => ApplyDiscount(discountCode)}>
						<FontAwesomeIcon icon={faArrowRight} />
					</button>
				</div>

				{typeof discountMessage === "string" && discountMessage && (
					<div className={`discount-message ${discountStatus !== "none" && discountStatus}`}>
						{discountMessage}
					</div>
				)}

				<PromoCodes />
			</div>
		</div>
	);
};

export default DiscountCode;
